<template dir="rtl">
  <!--  <splash></splash>-->
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>
    <!-- Jobs -->
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="d-flex justify-content-between">
              <h2 style="font-size: 1.2vw !important; text-align: right">ارزیابی نیازها و انتظارات ذی نفعان </h2>
              <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
            </div>
            <hr class="mb-3">
            <main class="row flex-nowrap">

               <div class="card w-50 d-flex flex-column  bg-white rounded align-items-center p-2 justify-content-center" style="height: 10vw;">
                 <p style="font-size: 1vw !important">ارزیابی نیاز ها و انتظارات به تفکیک ذی نفعان</p>
                 <router-link class="btn btn-primary btn-submit-1" to="/beneficiary_analytics_by_beneficiary">تکمیل</router-link>

               </div>
              <div class="card w-50 d-flex flex-column  bg-white rounded align-items-center p-2 mx-1 justify-content-center" style="height: 10vw;">
                <p style="font-size: 1vw !important">ارزیابی نیاز ها و انتظارات به تفکیک فرآیند</p>
                <router-link class="btn btn-primary btn-submit-1" to="/beneficiary_analytics_by_process">تکمیل</router-link>
              </div>


            </main>


          </div>
        </div>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error" v-show="statusEdit">
    <div>
      <p style="font-size: 1vw !important">ویرایش</p>
      <p @click="statusEdit=!statusEdit">❌</p>
    </div>
    <div>
      <input type="text" v-model="title" class="form-control">
      <button @click="update(id)">ویرایش</button>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-if="organ_modal"
       style="z-index: 999999999999999999999999999999999999999999999; ">
    <div>
      <p style="font-size: 1vw !important">واحدهای سازمانی </p>
      <p @click="organ_modal=!organ_modal">❌</p>
    </div>
    <div>
      <div style="overflow-y:scroll; width: 100%; height: 10vw;">
        <table class="table table-striped">
          <thead>
          <tr class="sticky-header">
            <th style="width: 1vw;">انتخاب</th>
            <th>کد</th>
            <th>عنوان</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in organization_all" :key="item.id">
            <td scope="row"><input :id="`item2_${item.id}`" v-model="inserterId3" type="radio" name="parent" :value="item['id']"></td>
            <td><label :for="`item2_${item.id}`">{{ item['id'] }}</label></td>
            <td>{{ item['name'] }}</td>
          </tr>

          </tbody>
        </table>
      </div>
      <button @click="select_inserterMethod3(item_id)">تایید</button>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="Beneficiaries_modal"
       style="z-index: 999999999999999999999999999999999999999999999;  ">
    <div>
      <p style="font-size: 1vw !important;">ذی نفعان </p>
      <p @click="Beneficiaries_modal=!Beneficiaries_modal">❌</p>
    </div>
    <div>

      <div style="overflow-y:scroll; width: 100%; height: 10vw;">

        <table class="table table-striped">
          <thead>
          <tr class="sticky-header">
            <th style="width: 1vw;">انتخاب</th>
            <th>کد</th>
            <th>عنوان</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in all_beneficiaries" :key="item.id">
            <td scope="row"><input :id="`item2_${item.id}`" v-model="inserterId3" type="radio" name="parent" :value="item['id']"></td>
            <td><label :for="`item2_${item.id}`">{{ item['id'] }}</label></td>
            <td>{{ item['name'] }}</td>
          </tr>

          </tbody>
        </table>
      </div>
      <button @click="select_inserterMethod3(item_id)">تایید</button>
    </div>
  </div>
</template>


<script>
import {useToast} from "vue-toastification";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Splash from "@/components/Splash/SplashWait.vue";
import Edit from "@/components/Icons/Edit.vue";

const toast = useToast();

export default {
  components: {Edit, Splash, Sidebar},
  data() {
    return {
      is_release: false,
      status: false,
      loader: false,
      statusEdit: false,
      organ_modal: false,
      Beneficiaries_modal: false,
      title: '',
      id: '',
      all_items: [],
      organization_all: [],
    }
  },
  methods: {
    updateChartData(id, value) {
      // Find the item by id and update the selected option
      const item = this.all_items.find((item) => item.id === id);
      if (item) {
        item.selectedOption = value;
      }
      // Update your chart data or any other logic here
    },
    releaseMethod() {
      this.is_release = false
      this.status = true
      this.loader = true
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow"
      };

      fetch(`${this.base_url}/StakeholderEvaluationQuestionnaire/store`, requestOptions)
          .then((response) => response.json())
          .then((response) => {

            setTimeout(() => {
              this.loader = false
              if (response.all) {
                this.all_items = response.all
              }
            }, 5000)
          })
          .catch((error) => console.error(error));


    },
    all() {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow"
      };

      fetch(`${this.base_url}/StakeholderEvaluationQuestionnaire`, requestOptions)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.status = response.status
            }
            if (response.all) {
              this.all_items = response.all
            }
          })
          .catch((error) => console.error(error));
    },
    editMethod(title,id) {
      this.title = title
      this.id = id
      this.statusEdit = true
    },
    update(id){

      const myHeaders = new Headers();
      const formData = new FormData();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      formData.append('title', this.title)
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formData,
        redirect: "follow"
      };

      fetch(`${this.base_url}/StakeholderEvaluationQuestionnaire/update/${id}`, requestOptions)
          .then((response) => response.json())
          .then((response) => {
            if (response.error){
              toast.error(response.error)
              return;
            }

            if (response.message){
              this.statusEdit=false
              this.all()
              toast.success(response.message)
            }
          })
          .catch((error) => console.error(error));



    },


  },

  mounted() {
    this.all()
  }
};
</script>
<style lang="scss" scoped>
p {
  font-size: 0.7vw !important;
}

label {
  text-align: right;
  font-size: 0.9vw !important;
}

input {
  z-index: 999999999999999999999999999999999999999999 !important;
}

.inputBox {
  width: 12vw !important;
}

.radioLabel p:last-child::before {
  left: 0.9vw;
  right: auto;
  bottom: -1.1vw !important;
}

.radioLabel p:nth-child(4) {
  right: 0.2vw !important;
}

.radioLabel p:nth-child(3) {
  right: -0.3vw !important;

}

.radioLabel p:nth-child(2) {
  right: -0.7vw !important;

}

.radioLabel p:nth-child(1) {
  //top: -0.5vw !important;

}

.radioLabel p:first-child::before, .radioLabel p:nth-child(3)::before {
  left: auto;
  bottom: -1.2vw;
}

img:hover {
  filter: unset !important;

}

.bg__create {
  background-image: url('../../assets/gifs/convert.gif');
  background-position: center;
  background-repeat: no-repeat;
  width: 15vw;
  height: 15vw;
  background-size: contain;
}


</style>
